<template>
  <div>
    <div class="flex flex-col w-full" v-if="notifications && notifications.length>0">
      <button v-for="notification in notifications" :key="notification.id"
        class="flex w-auto hover:font-bold break-words h-auto
        border-b border-black items-center py-6 pl-2"
        @click="readNotification(notification)"
        :class="notificationClass(notification)">
        <p :class="notification.read ? '' : 'font-black'" class="break-words">
          {{ notification.message }}
        </p>
      </button>
    </div>
    <div v-else class="p-4 text-gray-600">
      {{$t('notifications.none')}}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
// import AcceptNewLessonTime from '@/components/modals/AcceptNewLessonTime.vue';
// import StudentRejectsLesson from '@/components/modals/StudentRejectsLesson.vue';
import store from '../store';

export default {
  data() {
    return {
      selectedNotification: {},
      componentToOpen: '',
    };
  },

  computed: {
    ...mapGetters({
      notifications: 'auth/notifications',
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
      dashboardPath: 'auth/dashboardPath',
    }),

    notificationsToRead() {
      return this.notifications.filter((notification) => notification.read === 0);
    },

    iconColor() {
      if (this.user && this.isTeacher) {
        return 'hover:text-white';
      }
      return 'hover:text-chocolate-academy-600';
    },

    numberColor() {
      if (this.user && this.isTeacher) {
        return 'bg-white text-purple-500';
      }
      return 'bg-beige-academy-300 text-white';
    },
  },

  methods: {
    classType(read) {
      if (read === 0) return 'bg-beige-academy-200';
      return 'bg-white';
    },

    notificationClass(notification) {
      let classe = this.isTeacher ? 'border-grey-academy-200'
        : 'border-grey-academy-200';
      if (!notification.read) {
        classe += ' bg-orange-academy-300 border border-white text-white hover:bg-opacity-75';
      } else {
        classe += 'hover:bg-gray-100';
      }
      return classe;
    },

    setOverflow() {
      if (this.notifications.length > 7) return 'overflow-auto h-1/2';
      return '';
    },

    printDate(date) {
      const newDate = new Date(date);
      const hours = (newDate.getHours() < 10 ? '0' : '') + newDate.getHours();
      const minutes = (newDate.getMinutes() < 10 ? '0' : '') + newDate.getMinutes();
      return `${hours}:${minutes} ${newDate.getDay()}/${newDate.getMonth()}/${newDate.getFullYear()}`;
    },

    readNotification(notification) {
      this.selectedNotification = notification;
      this.$emit('open', notification);
      axios.put(`/api/notifications/${notification.id}/read`).then(() => {
        store.dispatch('auth/getNotifications');
      }).catch((errors) => {
        console.log(errors);
      });
    },

    closeNotifications() {
      this.seeNotifications = false;
    },
  },
};
</script>
